import { getFileCategory } from "@/shared/lib";
import { FilePreviewItem } from "./files-preview-item";
import { ResolvedFile } from "@/shared/hooks";


interface FilePreviewListProps {
  items: ResolvedFile[];
  showDelete: boolean;
  onDeleteFile?: (originalUrl: string) => void;
}

export const FilePreviewList = ({
  items,
  showDelete,
  onDeleteFile,
}: FilePreviewListProps) => {
  return (
    <>
      {items.map((item) => {
        const { original, resolved } = item;
        const category = getFileCategory(original);

        if (category === "audio") return null;

        return (
          <FilePreviewItem
            key={original}
            file={resolved}
            originalUrl={original}
            category={category}
            showDelete={showDelete}
            onDelete={() => onDeleteFile?.(original)}
          />
        );
      })}
    </>
  );
};
